module.exports = __webpack_public_path__ + "static/img/WRC8-logo.70df2cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/WRC8-logo.png
// module id = GVEA
// module chunks = 0